export default __webpack_public_path__ + "static/media/man.01cbaa27.svg";